import { lazy_loading_targets, setSrc } from "./lazy-loading-helper";

// Select all images
const images = document.querySelectorAll(lazy_loading_targets);

/**
 * Image Observer
 */
// Image observer options
const imgOptions = {
  threshold: 0,
  rootMargin: "0px 0px 200px 0px",
};
// Image observer if image is on viewport
const imgObserver = new IntersectionObserver((entries, imgObserver) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) {
      return;
    } else {
      // Set `src` by default to dark image variant if dark mode is enabled on page load
      setSrc(entry.target, document.body.classList.contains("dark"));
      imgObserver.unobserve(entry.target);
    }
  });
}, imgOptions);
// Set observer to all images
images.forEach((image) => {
  imgObserver.observe(image);
});

/**
 * Listen to click events on accessibility toggle for contrast
 */
const contrast_toggle = document.querySelector(
  "#acc-toggle-contrast .acc-toolbar__ctrl__button"
);
contrast_toggle?.addEventListener("click", () => {
  // Change `src` value of images if necessary to value for dark mode
  images.forEach((image) => {
    setSrc(
      image,
      contrast_toggle?.getAttribute("aria-pressed") === "false" ? true : false,
      true
    );
  });
});
